import React from "react";
import { ArrowUpRight } from "lucide-react";
import "../sass/landing/partnership.scss";

const PARTNERSHIP_EMAIL = "contato@psyassist.com.br";
const partnershipSubject = encodeURIComponent("Parceria com o PsyAssist Pro");
const partnershipBody = encodeURIComponent(
  [
    "Olá, time PsyAssist!",
    "",
    "Tenho interesse em conversar sobre uma possível parceria com o PsyAssist Pro.",
    "",
    "Nome:",
    "Perfil / projeto:",
    "Instagram / site:",
    "Como imagino a parceria:",
    "",
    "Obrigado(a)!",
  ].join("\n")
);

const Partnership = () => (
  <section id="parcerias" className="lp-partner" aria-labelledby="partnership-title">
    <div className="lp-shell lp-partner__grid">
      <div className="lp-partner__heading">
        <p className="lp-partner__eyebrow">Conexões que fazem sentido</p>
        <h2 id="partnership-title">Cria conteúdo ou reúne psicólogos?</h2>
      </div>

      <div className="lp-partner__body">
        <p>
          Vamos conversar. Perfis e canais que falam com psicólogos e
          estudantes, grupos de estudo, comunidades e eventos da área. Não
          temos um formato fechado de parceria: preferimos entender o que faz
          sentido para sua audiência e construir a ideia a partir daí.
        </p>
        <div className="lp-partner__actions">
          <a
            className="lp-link"
            href={`mailto:${PARTNERSHIP_EMAIL}?subject=${partnershipSubject}&body=${partnershipBody}`}
          >
            Propor uma parceria
            <ArrowUpRight size={16} aria-hidden="true" />
          </a>
          <a href={`mailto:${PARTNERSHIP_EMAIL}`} className="lp-partner__mail">
            {PARTNERSHIP_EMAIL}
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Partnership;
